import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import banner from "../../../assets/images/MedicationSync/med_sync_management.jpg";
import { FaRegDotCircle } from "react-icons/fa";
import img from "../../../assets/images/MedicationSync/OIP-removebg-preview.png";
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";


const MSync = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <Container>
      <TopServiceBanner title=" Med Sync" banner={banner} />
      <Inner>
        <Title>One Call, Accurate Refills</Title>
        <SubTitle>
          Did you know that approximately 70 million Americans take three or
          more prescriptions per day? That can mean many trips to the pharmacy
          for refills. With SyncRx and Lincourt  Pharmacy, your prescriptions
          are all filled on one day each month, and your pharmacist will
          coordinate the medications with your doctor for you.
          <br />
          <br />
          We make the calls to your doctor to make sure you always have refills
          on your medications and resolve any insurance issues in advance of
          your needing your prescriptions.
          <br />
          With SyncRx, you will receive one phone call each month from a
          pharmacist to review your medications so that we only fill the
          prescriptions you need.
          <br />
          And, for your convenience, Lincourt  Pharmacy offers you one free
          delivery or mailing each month of your SyncRx medications.
          <br />
          <br />
          Here is how the SyncRx Medication Refill program at Lincourt 
          Pharmacy works.
        </SubTitle>
        <Title>SyncRx Works For Patients and Caregivers</Title>
        <SubTitle>
          Refilling prescriptions all at once ensures patients do not miss
          refills and skip doses. SyncRX Refills is a free service for all Lincourt Pharmacy patients and their caregivers. Here is how it works.
        </SubTitle>
        <UUl>
          <LLi>
            <FaRegDotCircle />
            Bring in all prescriptions, vitamins, and supplements to your
            pharmacist.
          </LLi>
          <LLi>
            <FaRegDotCircle />
            The Pharmacist will synchronize all prescriptions leaving you with
            one day of the month for all to be refilled.
          </LLi>
          <LLi>
            <FaRegDotCircle />
            We will communicate with the doctor to be sure all dosages are
            correct and current.
          </LLi>
          <LLi>
            <FaRegDotCircle />
            Our team will coordinate with the insurance company.
          </LLi>
          <LLi>
            <FaRegDotCircle />
            Then, the Pharmacist will contact the patient after a month to see if any changes, side effects concerns or anything you no longer need.
          </LLi>
          <LLi>
            <FaRegDotCircle />
            Each month, your prescriptions are ready for pick-up or delivery, so
            you never run out.
          </LLi>
        </UUl>

        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Benefits of the SyncRx Med Refill Program
              </MiddleTextLeft>
              <Ul>
                <Li>
                  <FaRegDotCircle />
                  Meds will be refilled on the same day each month.
                </Li>
                <Li>
                  <FaRegDotCircle />
                  Patients will no longer run out of meds.
                </Li>
                <Li>
                  <FaRegDotCircle />
                  The program makes it easy for caregivers to administer the
                  correct meds too.
                </Li>
                <Li>
                  <FaRegDotCircle />A friendly staff member will contact the
                  patient a week before the prescriptions are to be refilled.
                </Li>
                <Li>
                  <FaRegDotCircle />
                  Fewer trips to the pharmacy and better communication with the
                  pharmacist.
                </Li>
                <Li>
                  <FaRegDotCircle />
                  Regular refills keep your meds on track, so you stay healthy.
                </Li>
              </Ul>
              <MiddleSubTitle>
                With all those benefits, our Lincourt  Pharmacy customers will
                see improved health and wellness. And that is precisely why we
                enjoy serving the good people of Lincourt . At PHP, you are
                not just another customer. We take your quality of life
                seriously, as well as the pharmacist/patient relationship
                created here.
              </MiddleSubTitle>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img} alt="multi dose pill packaging" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>
        <Title>Lincourt  Pharmacy and SyncRx</Title>
        <SubTitle>
          At Lincourt  Pharmacy, each team member is here to make your
          pharmacy experience stress-free and solve your medication-related
          problems. We will continue to find you affordable solutions while
          helping get you healthy and keeping you there!
          <br />
          <br />
          Caring beyond prescriptions, our expert team lives in your community
          and cares about you and your family’s overall health and wellness.
        </SubTitle>
      </Inner>
      <BottomServiceBanner />
      <BottomBanner />

    </Container>
  );
};

export default MSync;

const Container = styled.div``;
const Inner = styled.div``;

const SubTitle = styled.h2`
  font-size: 23px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const Middle = styled.div`
  background: var(--color-blue);
  clip-path: polygon(50% 10%, 100% 0, 100% 100%, 50% 90%, 0 100%, 0 0);
  padding-bottom: 5rem;
  padding-top: 5rem;
`;

const MiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const MiddleInner = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 3rem;
  gap: 1rem;

  @media (max-width: 1180px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }
`;

const MiddleInnerLeft = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
const MiddleInnerRight = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  color: white;
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 20px;
    margin-bottom: 2rem;
  }
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const Li = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
    padding: 0rem 0.5rem 0rem 1.5rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
const UUl = styled.ul`
  display: grid;
  gap: 0.5rem;
  justify-content: center;
  padding-top: 2rem;
  opacity: 0.6;
  margin-bottom: 1rem;
  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const LLi = styled.li`
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 23px;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
    padding: 0rem 0.5rem 0rem 1.5rem;
    font-size: 18px;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
    font-size: 15px;
  }
`;
const Img = styled.img`
  width: 100%;
  height: 65%;
  transform: scale(1.4);

  @media (max-width: 1180px) {
    width: 45%;
    height: 45%;
    margin-top: 1rem;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;
